<div class="sidebar__widget mb-50">
  <div class="sidebar__widget-title mb-25">
    <h3>Brand</h3>
  </div>
  <div class="sidebar__widget-content">
    <div class="brand">
      <ul>
        <li *ngFor="let b of brands; let i = index">
          <a
            class="cursor-pointer"
            (click)="handleBrand(b)"
            [class.active]="b.toLowerCase() === brand"
          >
            {{ b }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
